const labels = {
  vi: {
    Ginseng: "Sâm",
    Product: "Sản phẩm",
    ListInfo: "Danh sách thông tin",
    Certificate: "Giấy chứng nhận",
    Article: "Bài báo",
    Address: "Địa chỉ",
    AddNew: "Thêm mới",
    Search: "Tìm kiếm",
  },
  en: {
    Ginseng: "Sâm",
    Product: "Product",
    ListInfo: "List Information",
    Certificate: "Certificate",
    Article: "Article",
    Address: "Address",
    AddNew: "Add new",
    Search: "Search",
  },
};

export default labels;
